import type { ReduxError } from '@universal/errors';
import { produce } from 'immer';
import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { CenterProducts } from '../../../../types/centerArticleType';

export enum Actions {
  GET_CENTER_PRODUCTS_WITH_ID = 'naf/centers/GET_CENTER_PRODUCTS_WITH_ID',
  GET_CENTER_PRODUCTS_WITH_ID_SUCCESS = 'naf/centers/GET_CENTER_PRODUCTS_WITH_ID_SUCCESS',
  GET_CENTER_PRODUCTS_WITH_ID_FAIL = 'naf/centers/GET_CENTER_PRODUCTS_WITH_ID_FAIL',
  GET_CENTER_PRODUCTS_WITH_ID_CANCEL = 'naf/centers/GET_CENTER_PRODUCTS_WITH_ID_CANCEL',
}

export interface State {
  products: CenterProducts[] | null;
  isUpdating: boolean;
  errorState?: ReduxError;
}

export const initialState: State = {
  products: null,
  isUpdating: false,
};

export const actions = {
  getCenterProducts: createAsyncAction(
    Actions.GET_CENTER_PRODUCTS_WITH_ID, // request payload creator
    Actions.GET_CENTER_PRODUCTS_WITH_ID_SUCCESS, // success payload creator
    Actions.GET_CENTER_PRODUCTS_WITH_ID_FAIL, // failure payload creator
    Actions.GET_CENTER_PRODUCTS_WITH_ID_CANCEL, // optional cancel payload creator
  )<[string, { id?: number }], CenterProducts[], ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getCenterProducts.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = true;
    }),
  )
  .handleAction(actions.getCenterProducts.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.products = action.payload;
    }),
  )
  .handleAction(actions.getCenterProducts.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.errorState = action.payload;
    }),
  )
  .handleAction(actions.getCenterProducts.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
    }),
  );
